import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";

import { all as AllStats } from "../api/Stats";

import moment from "moment";

import { defineColor } from '../utils';

const CapacityDatePicker = (props) => {
  const { careUnitId } = props;
  const [stats, setStats] = useState([]);

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   */
  const loadStats = (startDate, endDate) => {
    let payload = {};
    if (careUnitId) {
      payload['care_unit_ids'] = [careUnitId];
    }

    AllStats(startDate, endDate, payload).then((data) => {
      setStats(data['stats']['stats']);
    });
  }

  const loadMouthStats = (date) => {
    if (props.disabled === false && careUnitId !== null) {
      let startOfMonth = date.clone().startOf('month').startOf('isoWeek');
      let endOfMonth = startOfMonth.clone().add(41, 'days');
  
      loadStats(startOfMonth, endOfMonth);
    }
  }

  /**
   *
   * @param {*} current
   */
  const onPanelChangeHandler = (current) => {
    loadMouthStats(current);

    if (props.onPanelChange) {
      props.onPanelChange(current);
    }
  }

  const onOpenChangeHandler = (current) => { }

  /**
   *
   * @param {*} current
   * @returns
   */
  const dateRenderHandler = (current) => {
    let currentDate = current.format('YYYYMMDD');
    let selectedDate = null;
    if (props.value) {
      selectedDate = props.value.format('YYYYMMDD');
    }

    let classCapacity = ["ant-picker-capacity", "row-data"];
    stats.forEach((stat) => {
      if (currentDate === stat.date) {
        classCapacity.push(defineColor(stat.occupancy_rate));
      }
    });

    if (selectedDate && currentDate === selectedDate) {
      classCapacity.push("ant-picker-selected");
    }

    return (
      <div className={classCapacity.join(' ')}>
        {current.date()}
      </div>
    );
  }

  useEffect(() => {
    let date = (props.value) ? props.value : moment();
    if (careUnitId !== null) {
      loadMouthStats(date);
    };
  }, [careUnitId, props.value]);

  return (
    <DatePicker
      {...props}
      onOpenChange={onOpenChangeHandler}
      onPanelChange={onPanelChangeHandler}
      dateRender={dateRenderHandler}
      allowClear={false}
      format="DD/MM/YYYY"
    />
  );
}

export default CapacityDatePicker;